import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbDatepickerModule, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

import { StandardCalculationInsuredSumComponent } from '../general-calculator/standard-calculation-insured-sum/standard-calculation-insured-sum.component';
import { StandardCalculationPremiumComponent } from '../general-calculator/standard-calculation-premium/standard-calculation-premium.component';
import { AdutCalculationInsuredSumComponent } from '../general-calculator/adut-calculation-insured-sum/adut-calculation-insured-sum.component';
import { AdutCalculationPremiumComponent } from '../general-calculator/adut-calculation-premium/adut-calculation-premium.component';
import { SecurityCalculationInsuredSumComponent } from '../general-calculator/security-calculation-insured-sum/security-calculation-insured-sum.component';
import { SecurityCalculationPremiumComponent } from '../general-calculator/security-calculation-premium/security-calculation-premium.component';
import { SecurityCreditComponent } from '../general-calculator/security-credit/security-credit.component';
import { ScholarshipCalculationInsuredSumComponent } from '../general-calculator/scholarship-calculation-insured-sum/scholarship-calculation-insured-sum.component';
import { ScholarshipCalculationPremiumComponent } from '../general-calculator/scholarship-calculation-premium/scholarship-calculation-premium.component';
import { GoldenAutumnComponent } from '../general-calculator/golden-autumn/golden-autumn.component';
import { NajlifeInsuredSumComponent } from '../general-calculator/najlife-insured-sum/najlife-insured-sum.component';
import { NajlifePremiumComponent } from '../general-calculator/najlife-premium/najlife-premium.component';

import { CalculatorsRoutingModule } from './calculators-routing.module';
import { ProgresiveComponent } from '../general-calculator/progresive/progresive.component';
import { SecurityCashComponent } from '../general-calculator/security-cash/security-cash.component';
import { VipStandardInsuranceSumComponent } from '../general-calculator/vip-standard-insurance-sum/vip-standard-insurance-sum.component';
import { VipStandardPremiumComponent } from '../general-calculator/vip-standard-premium/vip-standard-premium.component';
import { VipSecurityInsuredSumComponent } from '../general-calculator/vip-security-insured-sum/vip-security-insured-sum.component';
import { VipSecurityPremiumComponent } from '../general-calculator/vip-security-premium/vip-security-premium.component';
import { VipScholarshipInsuredSumComponent } from '../general-calculator/vip-scholarship-insured-sum/vip-scholarship-insured-sum.component';
import { VipScholarshipPremiumComponent } from '../general-calculator/vip-scholarship-premium/vip-scholarship-premium.component';


@NgModule({
  imports: [
    CommonModule,
    CalculatorsRoutingModule,
    HttpClientModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgbModalModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingBarHttpClientModule
  ],
  declarations: [
    StandardCalculationInsuredSumComponent,
    StandardCalculationPremiumComponent,
    AdutCalculationInsuredSumComponent,
    AdutCalculationPremiumComponent,
    SecurityCalculationInsuredSumComponent,
    SecurityCalculationPremiumComponent,
    SecurityCreditComponent,
    ScholarshipCalculationInsuredSumComponent,
    ScholarshipCalculationPremiumComponent,
    GoldenAutumnComponent,
    NajlifeInsuredSumComponent,
    NajlifePremiumComponent,
    ProgresiveComponent,
    SecurityCashComponent,
    VipStandardInsuranceSumComponent,
    VipStandardPremiumComponent,
    VipSecurityInsuredSumComponent,
    VipSecurityPremiumComponent,
    VipScholarshipInsuredSumComponent,
    VipScholarshipPremiumComponent
  ]
})
export class CalculatorsModule { }
